import { publicComponentOption } from "dependencies/base"
import { toSelectOpt } from "utils"
const optDes = {
  ...publicComponentOption,
  shapeType: "图片形状",
  borderTopLeftRadius: "边框左上角圆角",
  borderTopRightRadius: "边框右上角圆角",
  borderBottomLeftRadius: "边框左下角圆角",
  borderBottomRightRadius: "边框右下角圆角",
  borderStyle: "边框类型", // solid dashed dotted
  borderColor: "边框颜色",
  borderWidth: "边框宽度",
  borderIsThemeColor: "边框颜色为主题色",
  boxShadowColor: "边框阴影颜色",
  boxShadowH: "阴影x轴的偏移量",
  boxShadowV: "阴影y轴的偏移量",
  boxShadowBlur: "阴影模糊值",
  boxShadowSpread: "阴影扩散值",
  updateTimer: "数据轮询时间",
  restDataUrl: "外接数据源地址",
  clipSize: "裁剪方式",
  repeatType: "重复方式",
  alignType: "对齐方式",
  imgSrc: "图片链接",
  opacity: "透明度",
  openBlankPage: "点击跳转方式",
  linkUrl: "点击跳转地址",
  "boxShadowColor.0": "阴影颜色1"
}
export const getOptDes = toSelectOpt.bind(this, optDes)
